import React, { useEffect } from "react";
import { Input, Button, Select, Form } from "antd";
import { updatePlan } from "../../../api/plan";
import { useDispatch } from "react-redux";
import { getAllPlans } from "../../../redux/actions/AllActions";

const { Option } = Select;

const EditPlan = ({ plan, handleEditCancel }) => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();

    useEffect(() => {
        if (plan) {
            form.setFieldsValue({
                name: plan.name || "",
                price: plan.price || "",
                duration: plan.duration || "",
                benefits: plan.benefits ? [...plan.benefits] : [],
                planType: plan.planType || "",
            });
        }
    }, [plan, form]);

    const onFinish = async (values) => {
        try {
            await updatePlan({
                id: plan?._id,
                name: values.name,
                price: values.price,
                duration: values.duration,
                benefits: values.benefits,
                planType: values.planType,
            });
            fetchPlans();
            handleEditCancel();
        } catch (e) {
            console.log("The error in finishing the form is", e);
        }
    };

    const fetchPlans = () => {
        dispatch(getAllPlans());
    };

    return (
        <Form form={form} layout="vertical" onFinish={onFinish}>
            <Form.Item
                label="Name"
                name="name"
                rules={[{ required: true, message: "Please enter the plan name!" }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Price"
                name="price"
                rules={[{ required: true, message: "Please enter the price!" }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Duration"
                name="duration"
                rules={[{ required: true, message: "Please enter the duration!" }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Plan Type"
                name="planType"
                rules={[{ required: true, message: "Please select the plan type!" }]}
            >
                <Select placeholder="Select the plan type">
                    <Option value="Franchise">Franchise</Option>
                    <Option value="SellYourBusiness">Sell Your Business</Option>
                    <Option value="Dealership">Dealership</Option>
                    <Option value="Investor">Investor</Option>
                </Select>
            </Form.Item>

            {/* Benefits Section with Add, Remove, and Edit Functionality */}
            <Form.Item label="Benefits">
                <Form.List name="benefits">
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map((field, index) => (
                                <div key={field.key} style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                                    <Form.Item
                                        {...field}
                                        name={[field.name]}
                                        fieldKey={[field.fieldKey]}
                                        rules={[{ required: true, message: "Please enter a benefit!" }]}
                                        style={{ flex: 1 }}
                                    >
                                        <Input placeholder="Enter benefit" />
                                    </Form.Item>
                                    <Button type="danger" onClick={() => remove(field.name)}>-</Button>
                                </div>
                            ))}
                            <Button type="dashed" onClick={() => add()} style={{ marginTop: "10px" }}>
                                + Add Benefit
                            </Button>
                        </>
                    )}
                </Form.List>
            </Form.Item>

            <Form.Item>
                <Button type="primary" htmlType="submit">Submit</Button>
            </Form.Item>
        </Form>
    );
};

export default EditPlan;
